import { trpc } from '@client/utils/trpc';
import { Alert, Card, CardContent, CardProps, Skeleton, Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts';

export type VersionChartCardProps = CardProps & {
  chain: string | null;
  showOffline?: boolean;
};

export const VersionChartCard = ({ chain, showOffline, ...rest }: VersionChartCardProps) => {
  const { data, status, error } = trpc.chart.version.useQuery({
    chain,
    showOffline,
  });

  return (
    <Card {...rest}>
      <CardContent>
        <Typography variant={'h5'}>{'Version'}</Typography>

        {status === 'success' ? (
          <PieChart
            height={256}
            hideLegend
            series={[
              {
                data: data.map((item) => ({
                  label: item.version,
                  value: item.count,
                })),
              },
            ]}
          />
        ) : status === 'error' ? (
          <Alert severity={'error'}>{error.message}</Alert>
        ) : (
          <Skeleton variant={'rounded'} height={256} />
        )}
      </CardContent>
    </Card>
  );
};
